(function () {
    // Animates using the transitions in the CSS
    var rotatingWordElements = document.querySelectorAll('.rotating-word');

    // If there are no rotating word elements or the user prefers reduced motion, do nothing
    if (
        rotatingWordElements.length === 0 ||
        window.matchMedia(`(prefers-reduced-motion: reduce)`).matches
    ) {
        return;
    }

    rotatingWordElements.forEach(function (rotatingWordElement) {
        var words = rotatingWordElement.dataset.words.split('|');
        var currentWordIndex = 0;
        var totalWords = words.length;
        var wordElements = [rotatingWordElement.querySelector('span')];

        // Initializing width based on the first word to make transition smooth
        rotatingWordElement.style.width = wordElements[0].offsetWidth + 'px';

        // First word is visible from the start
        for (var i = 1; i < totalWords; i++) {
            var word = document.createElement('span');
            word.textContent = words[i];
            word.style.display = 'none';
            word.style.opacity = '0';
            rotatingWordElement.appendChild(word);
            wordElements.push(word);
        }

        setInterval(function () {
            var oldWordIndex = currentWordIndex;
            wordElements[oldWordIndex].style.opacity = '0';

            setTimeout(function () {
                wordElements[oldWordIndex].style.display = 'none';
            }, 300);

            currentWordIndex = (currentWordIndex + 1) % totalWords;

            wordElements[currentWordIndex].style.display = 'block';

            rotatingWordElement.style.width = wordElements[currentWordIndex].offsetWidth + 'px';
            wordElements[currentWordIndex].style.opacity = '1';
        }, 3000);
    });
})();
